import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';

import { useParams } from 'react-router-dom';

const EditEtatMajorSuccessifs = () => {
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState({
    nomprenom: '',
    du: '',
    au: '',
    file: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`etatmajorsuccessifs/${id}`);
        setInitialValues({
          nomprenom: response.data.nomprenom,
          du: response.data.du,
          au: response.data.au,
          file: null, // File won't be pre-filled
        });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [id]);

  const validationSchema = Yup.object({
    nomprenom: Yup.string().required('Nom et prénom sont requis'),
    du: Yup.date().required('Date de début est requise'),
    au: Yup.date().required('Date de fin est requise'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const formData = new FormData();
    formData.append('nomprenom', values.nomprenom);
    formData.append('du', values.du);
    formData.append('au', values.au);
    if (values.file) {
      formData.append('file', values.file);
    }

    try {
      await (
        await axios.put(`editetatmajor/edit/${id}`, formData)
      )
        .then((result) => {
          console.log(result.data);
        })
        .catch((err) => {
          console.log(err);
        });
      alert('Etat Major Successif mis à jour avec succès');
    } catch (error) {
      console.error(error);
      alert('Erreur lors de la mise à jour');
    }
    setSubmitting(false);
  };

  return (
    <div>
      <h1>Modifier un Etat Major Successif</h1>
      <Formik encType="multipart/form-data" enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ isSubmitting, setFieldValue }) => (
          <Form>
            <div>
              <label>Nom et Prénom</label>
              <Field name="nomprenom" />
            </div>
            <div>
              <label>Du</label>
              <Field name="du" type="date" />
            </div>
            <div>
              <label>Au</label>
              <Field name="au" type="date" />
            </div>
            <div>
              <label>Fichier</label>
              <input
                name="file"
                type="file"
                onChange={(event) => {
                  setFieldValue('file', event.currentTarget.files[0]);
                }}
              />
            </div>
            <button type="submit" disabled={isSubmitting}>
              Mettre à jour
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditEtatMajorSuccessifs;
